'use strict';
define([
    'angular',
    'modules/settings/users/users.controller'
], function (angular, UsersController) {
    var app = angular.module('settings.users', []);
    app.controller('UsersController', UsersController);
    return app;
});
